<template><div><icon-catalog></icon-catalog></div></template>


<script setup>
import IconCatalog from "@views/IconCatalog.vue";
</script>